/* PupFlask PDP
   1) Sticky mobile buy bar: reveal on scroll + one-tap add. When a bundle exists the bar shows
      "Add bottle + sling" (primary) and "Bottle only" (secondary), so the mobile one-tap path
      reinforces the bundle. The bottle-only button is a native form submit, so it adds even if
      this script never loads. Its own class (pf-sticky-cta, not sticky-cta) keeps it out of
      product-form.js's wiring, so there is no double add.
   2) Bottle + matching sling bundle card: one tap posts both line items to /cart/add.js and
      opens the drawer. No discount; both sizes stay above the free-shipping threshold.
   Scoped, idempotent (guards shopify:section:load double-init), no globals leaked. */
(function () {
  'use strict';

  function cartAtcAction() {
    try { return window.theme && theme.settings && theme.settings.cartDrawer && theme.settings.cartDrawer.atcAction; }
    catch (e) { return null; }
  }

  function sectionsToRender() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      try { return cartDrawer.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) {}
    }
    return [];
  }

  function openCartOrGo(sections) {
    if (cartAtcAction() === 'page') {
      window.location = (window.routes && window.routes.cart_url) || '/cart';
      return;
    }
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      return;
    }
    cartDrawer.classList.remove('is-empty');
    var items = cartDrawer.querySelector('cart-drawer-items');
    if (items) items.classList.remove('is-empty');
    if (sections && typeof cartDrawer.renderContents === 'function') {
      try { cartDrawer.renderContents({ sections: sections }, true); }
      catch (e) { if (typeof cartDrawer.reload === 'function') cartDrawer.reload(); }
      if (typeof window.loadTemplateContent === 'function') {
        try { window.loadTemplateContent(cartDrawer); } catch (e) {}
      }
    } else if (typeof cartDrawer.reload === 'function') {
      cartDrawer.reload();
    }
    if (typeof cartDrawer.open === 'function') cartDrawer.open();
  }

  // Shared AJAX add. onError(msg) optional; onDone() always runs.
  function addLineItems(lineItems, onError, onDone) {
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: JSON.stringify({ items: lineItems, sections: sectionsToRender(), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (data) { return { status: r.status, data: data }; }); })
      .then(function (res) {
        if (onDone) onDone();
        if (res.status >= 400) {
          if (onError) onError((res.data && (res.data.description || res.data.message)) || 'Could not add to cart.');
          return;
        }
        openCartOrGo(res.data && res.data.sections);
      })
      .catch(function () { if (onDone) onDone(); if (onError) onError('Something went wrong. Please try again.'); });
  }

  // Surface an error in the theme's existing product-form error element (buy-buttons.liquid
  // always renders one). Returns true if it was shown.
  function surfaceFormError(form, msg) {
    var host = form ? form.closest('product-form') : document.querySelector('product-form');
    var wrap = host && host.querySelector('.product-form__error-message-wrapper');
    var el = wrap && wrap.querySelector('.product-form__error-message');
    if (wrap && el) {
      el.textContent = msg;
      wrap.hidden = false;
      wrap.removeAttribute('hidden');
      var rect = wrap.getBoundingClientRect();
      if (rect.top < 100 || rect.bottom > window.innerHeight) {
        window.scrollTo({ top: rect.top + window.pageYOffset - 150, behavior: 'smooth' });
      }
      return true;
    }
    return false;
  }

  // Resolve the bottle + matching sling line items from a <pupflask-bundle> host, using the
  // currently selected bottle variant. Returns { form, items } (items is null if no variant).
  function bundleItemsFrom(host) {
    var formId = host.getAttribute('data-form-id');
    var form = formId ? document.getElementById(formId) : host.closest('form');
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var bottleId = idInput ? idInput.value : null;
    if (!bottleId) return { form: form, items: null };
    var pairs = {};
    try { pairs = JSON.parse(host.getAttribute('data-pairs') || '{}'); } catch (e) { pairs = {}; }
    var slingId = pairs[bottleId] || host.getAttribute('data-fallback-sling');
    var items = [{ id: Number(bottleId), quantity: 1 }];
    if (slingId) items.push({ id: Number(slingId), quantity: 1 });
    return { form: form, items: items };
  }

  // --- Sticky mobile buy bar ---
  function initSticky(bar) {
    if (bar.dataset.pfInit === '1') return;
    bar.dataset.pfInit = '1';

    var atc = bar.getAttribute('data-watch-atc') ? document.getElementById(bar.getAttribute('data-watch-atc')) : null;
    if (!atc || !('IntersectionObserver' in window)) {
      bar.classList.add('pf-sticky-cta--visible');
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { bar.classList.toggle('pf-sticky-cta--visible', !e.isIntersecting); });
      }, { rootMargin: '0px 0px -40px 0px', threshold: 0 });
      io.observe(atc);
    }

    var bottleBtn = bar.querySelector('button[type="submit"]');       // "Bottle only", or the single ATC when no bundle
    var bundleBtn = bar.querySelector('[data-pf-sticky-bundle]');     // "Add bottle + sling", present only when a bundle exists

    // Mirror the main Add-to-cart's disabled/sold-out state onto the sticky buttons. Reads the
    // main button and writes the sticky ones only, so the observer never re-triggers itself.
    if (atc) {
      var sync = function () {
        var off = atc.disabled || atc.getAttribute('aria-disabled') === 'true';
        if (bottleBtn) bottleBtn.disabled = off;
        if (bundleBtn) bundleBtn.disabled = off;
      };
      sync();
      if ('MutationObserver' in window) {
        new MutationObserver(sync).observe(atc, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      }
    }

    // Bottle-only / single ATC: AJAX single add (preventDefault cancels the native submit so
    // exactly one add happens); native submit is the no-JS fallback.
    if (bottleBtn) {
      bottleBtn.addEventListener('click', function (e) {
        if (bottleBtn.disabled) return;
        var form = bottleBtn.getAttribute('form') ? document.getElementById(bottleBtn.getAttribute('form')) : bottleBtn.closest('form');
        var idInput = form ? form.querySelector('[name="id"]') : null;
        var variantId = idInput ? idInput.value : null;
        if (!variantId) return; // let the native submit handle it
        e.preventDefault();
        if (bottleBtn.getAttribute('aria-disabled') === 'true') return;
        bottleBtn.setAttribute('aria-disabled', 'true');
        bottleBtn.classList.add('loading');
        var done = function () { bottleBtn.removeAttribute('aria-disabled'); bottleBtn.classList.remove('loading'); };
        addLineItems([{ id: Number(variantId), quantity: 1 }], function (msg) {
          if (!surfaceFormError(form, msg) && form && typeof form.requestSubmit === 'function') form.requestSubmit();
        }, done);
      });
    }

    // Add bottle + sling: reuse the bundle card's data so there is a single source of truth.
    if (bundleBtn) {
      bundleBtn.addEventListener('click', function () {
        if (bundleBtn.disabled || bundleBtn.getAttribute('aria-disabled') === 'true') return;
        var host = document.querySelector('pupflask-bundle');
        if (!host) return;
        var b = bundleItemsFrom(host);
        if (!b.items) { surfaceFormError(b.form, 'Please choose a color first.'); return; }
        bundleBtn.setAttribute('aria-disabled', 'true');
        bundleBtn.classList.add('loading');
        var done = function () { bundleBtn.removeAttribute('aria-disabled'); bundleBtn.classList.remove('loading'); };
        addLineItems(b.items, function (msg) { surfaceFormError(b.form, msg); }, done);
      });
    }
  }

  // --- Bundle card ---
  function initBundle(host) {
    if (host.dataset.pfInit === '1') return;
    host.dataset.pfInit = '1';

    var btn = host.querySelector('[data-pf-bundle-add]');
    if (!btn) return;
    var errorEl = host.querySelector('[data-pf-bundle-error]');

    function showError(msg) { if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; } }
    function clearError() { if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; } }
    function setLoading(on) { host.classList.toggle('is-loading', on); btn.setAttribute('aria-disabled', on ? 'true' : 'false'); }

    btn.addEventListener('click', function () {
      if (host.classList.contains('is-loading')) return;
      clearError();
      var b = bundleItemsFrom(host);
      if (!b.items) { showError('Please choose a color first.'); return; }
      setLoading(true);
      addLineItems(b.items, showError, function () { setLoading(false); });
    });

    // Color-reactive sling image: swap the card thumbnail to the sling that matches the
    // selected bottle color, so the customer sees the set recolor as they pick.
    var img = host.querySelector('.pf-bundle__img');
    var slingImages = {};
    try { slingImages = JSON.parse(host.getAttribute('data-sling-images') || '{}'); } catch (e) { slingImages = {}; }
    if (img && Object.keys(slingImages).length) {
      var imgFormId = host.getAttribute('data-form-id');
      var imgForm = imgFormId ? document.getElementById(imgFormId) : host.closest('form');
      var syncImg = function () {
        var idInput = imgForm ? imgForm.querySelector('[name="id"]') : null;
        var vid = idInput ? idInput.value : null;
        if (vid && slingImages[vid] && img.getAttribute('src') !== slingImages[vid]) {
          img.setAttribute('src', slingImages[vid]);
        }
      };
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(syncImg, 0); });
      }
      if (imgForm) imgForm.addEventListener('change', function () { setTimeout(syncImg, 0); });
      syncImg();
    }
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-pf-sticky-cta]').forEach(initSticky);
    scope.querySelectorAll('pupflask-bundle').forEach(initBundle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
})();
